export default function createIngredientFromChoice({
  choice,
  choiceSetId,
  ingredients,
  mimCategoryId,
}: {
  choice: ChoiceWithQuantity | NestedChoiceWithQuantity;
  choiceSetId: string;
  ingredients?: CartIngredient[];
  mimCategoryId?: string;
}): CartIngredient {
  return {
    Price: choice.baseMoneyPrice,
    PLUCode: parseInt(choice.plucode),
    ProductID: parseInt(choice.id),
    Qty: choice.quantity,
    Ingredients: ingredients ? ingredients : [],
    ChoicesetID: parseInt(choiceSetId),
    Points: choice.basePointsPrice,
    mimCategoryId,
  };
}
